module.exports = __webpack_public_path__ + "img/train_accident.8a5b75bc.svg";